import TelemetryService from "./telemetryService";

let registered = false;

export function registerGlobalErrorHandlers(): void {
  if (registered) {
    return;
  }
  registered = true;

  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    const error = reason instanceof Error ? reason : new Error(String(reason));
    TelemetryService.AppInsights?.trackException({
      exception: error,
      properties: { source: "unhandledrejection" },
    });
  });

  window.addEventListener("error", (event: ErrorEvent) => {
    const error = event.error instanceof Error ? event.error : new Error(event.message);
    TelemetryService.AppInsights?.trackException({
      exception: error,
      properties: { source: "window.error" },
    });
  });
}
